import { jhsWorks } from './images/jhs/works';
import { lskWorks } from './images/lsk/works';
import { kbbWorks } from './images/kbb/works';
import { gheWorks } from './images/ghe/works';
import { ajmWorks } from './images/ajm/works';
import { jnsWorks } from './images/jns/works';
import { krnWorks } from './images/krn/works';
import { oskarWorks } from './images/oskar/works';
import { cwkWorks } from './images/cwk/works';

import {
  ajmProfile,
  cwkProfile,
  gheProfile,
  jhsProfile,
  jnsProfile,
  krnProfile,
  kbbProfile,
  lskProfile,
  oskarProfile,
} from './images';

export const MAIN = [];

export const ARTISTS = [];

export const ARTIST_DETAILS = {
  jhs: {
    id: 'jhs',
    nameKor: '정혜선',
    nameEng: 'Jung Hye Seon',
    profile: {
      circle: '',
      representative: '',
      images: jhsProfile,
    },
    works: jhsWorks,
    bio: {
      birth: '1942.02.21',
      debut: '1961년 KBS 공채 1기 탤런트',
      awards: [
        '2010 MBC 연기대상 공로상',
        '2010 대중문화 예술상 국무총리 표창',
        '2009 MBC 연기대상 황금연기상',
        '1994 백상예술대상 최우수 연기상'
      ],
    },
  },
  lsk: {
    id: 'lsk',
    nameKor: '이수경',
    nameEng: 'Lee Su Kyung',
    profile: {
      circle: '',
      representative: '',
      images: lskProfile,
    },
    works: lskWorks,
    bio: {
      birth: '1982.03.13',
      debut: '2003년 CF \'화이트\'',
      awards: [
        '2010년 SBS 연기대상 드라마스페셜부문 여자 조연상',
        '2009년 SBS 연기대상 10대 스타상',
        '2009년 앙드레 김 베스트 스타 어워드 스타상',
        '2007년 KBS 연기대상 여자 신인상',
        '2007년 KBS 연기대상 베스트커플상 (with 김지훈)'
      ],
    },
  },
  kbb: {
    id: 'kbb',
    nameKor: '김비비',
    nameEng: 'Kim Bibi',
    profile: {
      circle: '',
      representative: '',
      images: kbbProfile,
    },
    works: kbbWorks,
    bio: {
      birth: '1978.02.22',
      debut: '1998년 뮤지컬 \'찬파만파 장보고여\'',
      awards: [],
    },
  },
  ghe: {
    id: 'ghe',
    nameKor: '길하은',
    nameEng: 'Gil Ha Eun',
    profile: {
      circle: '',
      representative: '',
      images: gheProfile,
    },
    works: gheWorks,
    bio: {
      birth: '1993.07.05',
      debut: '2019년 뮤지컬 \'그리스\'',
      awards: [],
    },
  },
  ajm: {
    id: 'ajm',
    nameKor: '안재모',
    nameEng: 'Ahn Jae Mo',
    profile: {
      circle: '',
      representative: '',
      images: ajmProfile,
    },
    works: ajmWorks,
    bio: {
      birth: '1979.09.20',
      debut: '1996년 KBS 드라마 \'신세대 보고 - 어른들은 몰라요\'',
      awards: [
        '2003년 백상예술대상 인기상',
        '2002년 SBS 연기대상 대상',
        '2002년 SBS 연기대상 10대 스타상',
        '2001년 SBS 연기대상 단막극 부문 연기상',
        '2000년 제36회 백상예술대상 TV부문 남자 신인연기상'
      ],
    },
  },
  jns: {
    id: 'jns',
    nameKor: '장남수',
    nameEng: 'Jang Nam Su',
    profile: {
      circle: '',
      representative: '',
      images: jnsProfile,
    },
    works: jnsWorks,
    bio: {
      birth: '1989.07.23',
      debut: '2020년 영화 \'해적2\'',
      awards: [],
    },
  },
  krn: {
    id: 'krn',
    nameKor: '김리나',
    nameEng: 'Kim Ri-na',
    profile: {
      circle: '',
      representative: '',
      images: krnProfile,
    },
    works: krnWorks,
    bio: {
      birth: '1999.12.07',
      debut: 'HarryIM \'첫사랑\' 뮤직비디오',
      awards: [],
    },
  },
  oskar: {
    id: 'oskar',
    nameKor: 'OSKAR KEEM',
    nameEng: 'OSKAR KEEM',
    profile: {
      circle: '',
      representative: '',
      images: oskarProfile,
    },
    works: oskarWorks,
    bio: {
      birth: '1993.07.10',
      debut: '2017년 3월',
      awards: [],
    },
  },
  cwk: {
    id: 'cwk',
    nameKor: '천우경',
    nameEng: 'Chun Woo-Kyoung',
    profile: {
      circle: '',
      representative: '',
      images: cwkProfile,
    },
    works: cwkWorks,
    bio: {
      birth: '1991.07.07',
      debut: '2016년 2월',
      awards: [],
    },
  },
};
